export default __webpack_public_path__ + "static/furnace-repair-service-7859f705a85a4437413e0fcb0aee1820.png";